import { Form, Layout, notification } from "antd";
import style from "./sell.module.less";
import i18n, { languageKeys } from "../../../../i18n";
import SiderPayment from "./SiderPayment";
import TableSell from "./TableSell";
import { useDispatch, useSelector } from "react-redux";
import { doFetchSupplyList, doSavePayment, getSellData, resetSellSlice } from "ducks/slices/QlyVienPhi/BanThuoc.slice";
import { getSharedData } from "ducks/slices/ListData/SharedData.slice";
import { useEffect, useRef, useState } from "react";
import { calcTotal } from "helpers";
import FooterSell from "./FooterSell";
import _ from "lodash";
import { ModalPDF } from "components";
import { apis } from "../../../../constants";

const BanThuoc = ({ patient, checkPermission }) => {

  const pdfRef = useRef();

  const dispatch = useDispatch()
  const { initList } = useSelector(getSellData)
  const { paymentMethod } = useSelector(getSharedData);

  const [form] = Form.useForm()

  const [receiptsList, setReceiptsList] = useState([])
  const [receiptInfo, setReceiptInfo] = useState({})
  const [expandedRows, setExpandedRows] = useState([])


  useEffect(() => {
    patient && dispatch(doFetchSupplyList(patient))
    return () => {
      dispatch(resetSellSlice())
    }
  }, [patient])


  // khởi tạo dữ liệu
  useEffect(() => {
    if (initList[0]) {

      // Format list
      const formatList = initList.map(item => {
        if (item.TRANG_THAI_PHIEU === 'CHO_DUYET') {
          return {
            ...item,
            CHI_TIET_PHIEU_VAT_TU: item.CHI_TIET_PHIEU_VAT_TU.map(i => {
              if (i.MA_LO) {
                return {
                  ...i,
                  THANH_TIEN: i.SO_LUONG * i.GIA_BAN,
                }
              } else {
                const lovt = _.orderBy(i.LO_VAT_TU, ["HAN_SU_DUNG"], ["asc"])[0] || {}
                return {
                  ...i, ...lovt,
                  THANH_TIEN: i.SO_LUONG * lovt.GIA_BAN,
                }
              }
            }),
            ID: item.PHIEU_BAN_VAT_TU_ID,
          }
        } else return {
          ...item,
          ID: item.PHIEU_BAN_VAT_TU_ID,
        };
      })
      setReceiptsList(formatList)
      setExpandedRows(formatList.flatMap(i => i.ID))

      // Fill form
      const selected = formatList.filter(i => !i.TRANG_THAI_THANH_TOAN)?.[0]
      if (selected) {
        setReceiptInfo(selected)
        form.setFields([
          {
            name: "LIST_HINH_THUC_THANH_TOAN",
            value: [{
              HINH_THUC_THANH_TOAN_ID: paymentMethod.find(i => i.PHAN_LOAI_HINH_THUC === "TIEN_MAT")?.ID,
              BENH_NHAN_DUA: calcTotal(selected.CHI_TIET_PHIEU_VAT_TU, "THANH_TIEN")
            }]
          },
          {
            name: "TIEN_KHACH_DUA",
            value: calcTotal(selected.CHI_TIET_PHIEU_VAT_TU, "THANH_TIEN")
          },
          {
            name: "MIEN_GIAM",
            value: undefined
          },
        ])
      }

    } else {
      setReceiptsList([])
      setReceiptInfo({})
      form.resetFields()
    }
  }, [initList])


  // In
  const handlePrint = (ID) => {
    pdfRef.current.openModal({ PHIEU_BAN_VAT_TU_ID: ID }, apis.layDataHoaDonBanVatTu)
  }


  // Thanh toán
  const handleSubmitPayment = async (print = false) => {

    const data = await form.validateFields()

    const dataSource = receiptInfo.CHI_TIET_PHIEU_VAT_TU

    const TONG_CHI_PHI = dataSource.reduce((tol, obj) => tol + obj.SO_LUONG * obj.GIA_BAN, 0)

    const MIEN_GIAM = calcTotal(dataSource, "TONG_MIEN_GIAM") + (
      data.MIEN_GIAM
        ? data.MIEN_GIAM > 100
          ? data.MIEN_GIAM
          : calcTotal(dataSource, "THANH_TIEN") / 100 * data.MIEN_GIAM
        : 0
    )

    const TONG_THANH_TOAN = TONG_CHI_PHI - (
      MIEN_GIAM
        ? MIEN_GIAM > 100
          ? MIEN_GIAM
          : calcTotal(dataSource, "THANH_TIEN") / 100 * MIEN_GIAM
        : 0
    )

    if (MIEN_GIAM > TONG_CHI_PHI) {
      return notification.warning({ message: i18n.t(languageKeys.error_Gia_tri_mien_giam_ko_hop_le) })
    }

    const listData = dataSource
      .map(i => ({
        ..._.omit(i, ['LO_VAT_TU', 'value', 'label']),
        DON_GIA: i.GIA_BAN,
        TONG_MIEN_GIAM: data.MIEN_GIAM
          ? data.MIEN_GIAM > 100
            ? Math.round((i.TONG_MIEN_GIAM ?? 0) + (i.THANH_TIEN * data.MIEN_GIAM / calcTotal(dataSource, "THANH_TIEN")))
            : Math.round((i.TONG_MIEN_GIAM ?? 0) + (i.THANH_TIEN / 100 * data.MIEN_GIAM))
          : i.TONG_MIEN_GIAM,
        MIEN_GIAM_PHAN_TRAM: data.MIEN_GIAM ? 0 : i.MIEN_GIAM_PHAN_TRAM,
        TRANG_THAI: !!i.MA_LO ? 1 : 0
      }))

    const payloadR = {
      PHIEU_BAN_VAT_TU_ID: receiptInfo.ID,
      TONG_TIEN: TONG_CHI_PHI,
      MIEN_GIAM_PHAN_TRAM: null,
      TONG_MIEN_GIAM: MIEN_GIAM,
      TONG_THANH_TOAN,
      CHI_TIET_PHIEU_BAN_VAT_TU: listData
    }

    const payloadP = {
      ...data,
      PHIEU_BAN_VAT_TU_ID: receiptInfo.ID,
      TONG_CHI_PHI,
      MIEN_GIAM,
      TONG_THANH_TOAN,
      MIEN_GIAM_PHAN_TRAM: null,
      TIEN_THUA: Math.max(0, data.TIEN_KHACH_DUA - TONG_THANH_TOAN),
      BENH_NHAN_DUA: calcTotal(data.LIST_HINH_THUC_THANH_TOAN, "BENH_NHAN_DUA"),
      LIST_DV: listData,
    }

    // Call api
    dispatch(doSavePayment({
      dataR: payloadR,
      dataP: payloadP,
      afterSuccess: () => {
        print && handlePrint(receiptInfo.ID)
        dispatch(doFetchSupplyList(patient))
      },
    }))
  }


  return (
    <Layout>

      <Layout>
        <Layout.Content className={style.content}>
          <h2 className={style.title}>{i18n.t(languageKeys.thong_tin_don_thuoc)}</h2>
          <TableSell
            form={form}
            receiptsList={receiptsList}
            setReceiptsList={setReceiptsList}
            receiptInfo={receiptInfo}
            setReceiptInfo={setReceiptInfo}
            expandedRows={expandedRows}
            setExpandedRows={setExpandedRows}
            patient={patient}
            handlePrint={handlePrint}
            checkPermission={checkPermission}
          />
        </Layout.Content>

        {!receiptsList.every(i => i.TRANG_THAI_THANH_TOAN) && (
          <SiderPayment
            form={form}
            supplyList={receiptInfo.CHI_TIET_PHIEU_VAT_TU}
          />
        )}
      </Layout>

      <FooterSell
        pdfRef={pdfRef}
        receiptsList={receiptsList}
        handleSubmitPayment={handleSubmitPayment}
        checkPermission={checkPermission}
      />

      <ModalPDF ref={pdfRef} />

    </Layout>
  )
}

export default BanThuoc;